module.exports = __webpack_public_path__ + "2896ac70813ca9e4768ab8a727f25c47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/earbuds-yellow.png
// module id = 1806
// module chunks = 0